<div [style.display]="'block'">
  <div>

    <mat-form-field class="w-100">
      <mat-label>Check #</mat-label>
      <input class="ta-prepay-checkno" matInput placeholder="" (keypress)="numbersOnly($event)" type="number" [(ngModel)]="prepayRemarks.chequeNo">
    </mat-form-field>
    <br>
    <mat-form-field class="w-100">
      <input class="ta-prepay-startingdate" [min]="minDate" matInput [matDatepicker]="checkDate" placeholder="Check Postmark Date"
        (dateChange)="validateDates()" [(ngModel)]="prepayRemarks.chequeDate" data-hj-whitelist>
      <mat-datepicker-toggle matSuffix [for]="checkDate" ></mat-datepicker-toggle>
      <mat-datepicker #checkDate></mat-datepicker>
      
    </mat-form-field>

    <mat-form-field class="w-100">
      <mat-label>Check Amount</mat-label>
      <input matInput placeholder="" disabled [(ngModel)]="prepayRemarks.chequeAmount" [appTwoDecimalNumber]="true"
        type="number" onlyNumber="true" maxlength="10" min="0">
    </mat-form-field>
    <div style="text-align: left;">
      <mat-checkbox class="ta-prepay-byphonecall" (change)="changeIsByPhone($event)" [(ngModel)]="prepayRemarks.isByPhone" color="primary">By Phone
        Call</mat-checkbox>
    </div>
    <mat-form-field class="w-100">
      <textarea class="ta-prepay-remarks" matInput [maxLength]="maxIncidentDescriptionLength" [(ngModel)]="prepayRemarks.prepayRemarks"
        placeholder="Remarks"></textarea>
      <small class="form-text text-muted">
        <code>{{prepayRemarks.prepayRemarks.length}}</code> of
        <code>{{maxIncidentDescriptionLength}}</code> characters
      </small>
    </mat-form-field>
    <br>
    <div *ngIf="isSign" class="margin_20" style="border:0px solid rgb(255, 253, 253) !important;">
      <div *ngIf="isSign && !signatureImage">

        <span>
          <span style="color: red;" *ngIf="isSignatureRequired">*signature is required </span>
          <br>        
          <app-signature-pad
            #signature
            style="background-color: white !important;"
            [height]="200"
            [minWidth]="5"
            backgroundColor="#ffffff"
            (drawStart)="drawStart()"></app-signature-pad>
          <br>

        </span>
        <button mat-button class="text-white btn btn-success" (click)="drawComplete()">Done</button>
        &nbsp;
       <button mat-button class="text-white btn btn-warning pull-right" (click)="clear()">Clear</button>
      </div>
      <div *ngIf="signatureImage">
        <app-signature-pad
          [readonly]="true"
          [height]="200"
          [value]="signatureImage"
          backgroundColor="#ffffff"></app-signature-pad>
        <div>
          <br>
          <button mat-button class="ta-prepay-resign text-white btn btn-warning" (click)="resign()">
            Re-Sign
          </button>
        </div>
      </div>
      <br>
    </div>
    <br>
    <div>
      <button mat-button class="mat-mdc-button-RedBackground-WhiteText ta-prepay-cancel magin_5 text-white btn btn-danger" (click)="cancel()">Cancel</button>
      <button [disabled]="isSign" mat-button class="ta-prepay-sign magin_5 text-white btn btn-info" (click)="sign()">Sign</button>
      <button [disabled]="isSignatureRequired" mat-button [ngClass]="'ta-prepay-finish magin_5 text-white btn btn-'+globals.colorTheme"
        (click)="finishPrepay()"> {{showFarmAndFields? 'Prepay Single':'Prepay'}}</button>
      <button [disabled]="isSignatureRequired" *ngIf="showFarmAndFields" mat-button class="mat-stroked-button-WhiteBackground-GreenText ta-quote-split magin_5 color_green"
        (click)="finishSplitPrepay()">Prepay Split</button>
    </div>
  </div>
</div>